import { FilterMatchMode } from "primereact/api";
import ColorUtils from "../components/utils/ColorUtils";
import IconColorComponent from "../components/inputs/IconColorComponent";

export default class TemplateUtils {
    
    static enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }


    static getValueByPath = (obj, path) => path.split('.').reduce((acc, key) => acc && acc[key], obj);

    static multiselectColoredItemTemplate(item, itemLabel, chipColor, removable, value, onChange) {
        
        const backgroundColor = item ? TemplateUtils.getValueByPath(item, chipColor) : '#ffffffff';        
        const fontColor = item ? ColorUtils.getContrastingColor(backgroundColor) : '#000000';
        if (item != null) {
            return (
                <div className='p-multiselect-token p-readonly' style={{ background: item.color.value, color: fontColor}}>
                    <div className="p-multiselect-token-label p-readonly" >
                        {item[itemLabel]}
                    </div>
                    {removable ? (
                    <div className="p-multiselect-token-icon pi pi-times-circle" onClick={(e) => {                        
                        const newValue = value.filter(v => v !== item);                        
                        if (onChange) {
                            onChange(newValue);
                        }                        
                    }
                    }>
                    </div>
                    ) : null}
                </div>
            );
        }
        return null;
    }


    static multiselectColoredIconItemTemplate(item, itemLabel, iconValue, colorValue, removable, value, onChange) {
        const icon = TemplateUtils.getValueByPath(item, iconValue);
        const color = TemplateUtils.getValueByPath(item, colorValue);
        return item ? 
        <div className='p-multiselect-token'>
            <IconColorComponent                
                fontSize={"20px"}
                icon={icon}
                color={color}
            />
            <span>
                {item[itemLabel]}
            </span>
            {removable ? (
            <div className="p-multiselect-token-icon pi pi-times-circle" onClick={(e) => {
                const newValue = value.filter(v => v !== item);                        
                if (onChange) {
                    onChange(newValue);
                }                        
            } 
            }></div>
        ) : null }
        </div>
        :
        null
    }

    
}


